export default __webpack_public_path__ + "static/media/quicktips.cf183233.jpg";